import { connect } from 'react-redux';
import { Route } from './Route.component';
import { ROUTES } from 'shared/constants';
import { isAuthenticated } from 'shared/store/selectors/auth.selector';
// eslint-disable-next-line no-unused-vars
import UserService from 'shared/services/user.service'; // Keep: ensures correct module initialization order

const mapStateToProps = ({ auth }) => {
  return {
    isAllowedRoute: isAuthenticated({ auth }),
    redirectRoute: ROUTES.ROOT,
    shouldRestoreIntendedRoute: true,
    auth,
  };
};

export const AuthRoute = connect(mapStateToProps)(Route);
